import { gql } from '@apollo/client';

export const CASH_SHIFT_FIELDS = gql`
  fragment CashShiftFields on CashShift {
    id
    branch_id
    cash_register_id
    cashier_id
    opened_by
    closed_by
    folio_number
    status
    initial_fund_cents
    opened_at
    closed_at
    notes
    created_at
    updated_at
  }
`;

export const CASH_MOVEMENT_FIELDS = gql`
  fragment CashMovementFields on CashMovement {
    id
    cash_shift_id
    branch_id
    kind
    amount_cents
    reason
    reference_kind
    reference_id
    folio_number
    status
    created_by
    created_at
  }
`;

export const CASH_CUT_FIELDS = gql`
  fragment CashCutFields on CashCut {
    id
    cash_shift_id
    folio_number
    initial_fund_cents
    expected_cash_cents
    declared_cash_cents
    difference_cents
    credit_card_cents
    debit_card_cents
    abonos_cents
    cash_in_cents
    cash_out_cents
    cancelled_sales_cents
    discounts_cents
    calculation_version
    snapshot_json
    notes
    status
    created_at
  }
`;

export const MY_ACTIVE_CASH_SHIFT_QUERY = gql`
  ${CASH_SHIFT_FIELDS}
  query MyActiveCashShift {
    myActiveCashShift {
      ...CashShiftFields
    }
  }
`;

export const MY_CASH_SHIFT_STATUS_QUERY = gql`
  query MyCashShiftStatus {
    myCashShiftStatus {
      has_own_open_shift
      has_branch_open_shift
      branch_open_shift_cashier_name
    }
  }
`;

export const CASHIER_ACTIVE_SHIFT_QUERY = gql`
  ${CASH_SHIFT_FIELDS}
  query CashierActiveShift($cashier_id: ID!) {
    cashierActiveShift(cashier_id: $cashier_id) {
      ...CashShiftFields
    }
  }
`;

export const CASH_SHIFTS_QUERY = gql`
  ${CASH_SHIFT_FIELDS}
  query CashShifts(
    $offset: Int
    $limit: Int
    $cashier_id: ID
    $cash_register_id: ID
    $status: CashShiftStatus
    $branch_id: ID
  ) {
    cashShifts(
      offset: $offset
      limit: $limit
      cashier_id: $cashier_id
      cash_register_id: $cash_register_id
      status: $status
      branch_id: $branch_id
    ) {
      items {
        ...CashShiftFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const CASH_MOVEMENTS_QUERY = gql`
  ${CASH_MOVEMENT_FIELDS}
  query CashMovements($cash_shift_id: ID, $offset: Int, $limit: Int) {
    cashMovements(cash_shift_id: $cash_shift_id, offset: $offset, limit: $limit) {
      items {
        ...CashMovementFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const OPEN_CASH_SHIFT_MUTATION = gql`
  ${CASH_SHIFT_FIELDS}
  mutation OpenCashShift($input: OpenCashShiftInputGql!) {
    openCashShift(input: $input) {
      ...CashShiftFields
    }
  }
`;

export const CLOSE_CASH_SHIFT_MUTATION = gql`
  ${CASH_CUT_FIELDS}
  mutation CloseCashShift($input: CloseCashShiftInputGql!) {
    closeCashShift(input: $input) {
      shift_id
      cut {
        ...CashCutFields
      }
    }
  }
`;

export const ADD_CASH_IN_MUTATION = gql`
  ${CASH_MOVEMENT_FIELDS}
  mutation AddCashIn($input: AddCashMovementInputGql!) {
    addCashIn(input: $input) {
      ...CashMovementFields
    }
  }
`;

export const ADD_CASH_OUT_MUTATION = gql`
  ${CASH_MOVEMENT_FIELDS}
  mutation AddCashOut($input: AddCashMovementInputGql!) {
    addCashOut(input: $input) {
      ...CashMovementFields
    }
  }
`;

export const SURPRISE_CASH_COUNT_MUTATION = gql`
  ${CASH_MOVEMENT_FIELDS}
  mutation SurpriseCashCount($input: SurpriseCountInputGql!) {
    surpriseCashCount(input: $input) {
      movement {
        ...CashMovementFields
      }
      expected_cash_cents
      declared_cash_cents
      difference_cents
    }
  }
`;

export const CASHIER_USERS_QUERY = gql`
  query CashierUsers {
    cashierUsers {
      id
      email
      full_name
    }
  }
`;

export const CASH_REGISTERS_FOR_SHIFT_QUERY = gql`
  query CashRegistersForShift($branch_id: ID, $offset: Int, $limit: Int) {
    cashRegisters(branch_id: $branch_id, offset: $offset, limit: $limit, status_filter: ACTIVE) {
      items {
        id
        branch_id
        name
        status
      }
    }
  }
`;
